import React, { useState } from 'react';
import styled, { css } from 'styled-components/macro';


const Button = ({ children, onClick, toggle, active, ...props }) => {
    const [ isToggled, setIsToggled ] = useState(false);
    
    // Use active prop if provided, otherwise use internal toggle state
    const isActive = active !== undefined ? active : isToggled;
    
    const handleClick = (event) => {
        if (toggle && active === undefined) {
            setIsToggled(!isToggled);
        }
        
        if (onClick) onClick(event);
    };

    const asProp = props.href ? { as: 'a' } : {};
    
    return (
        <StyledButton {...asProp} {...props} onClick={handleClick} data-active={isActive || undefined}>
            <span>{(toggle && isActive && toggle !== true) ? toggle : children}</span>
        </StyledButton>
    );
};


export default Button;


const activeStyles = css`
    color: white;
    background: ${props => props.theme.secondary_color};
    border-color: transparent;
    
    &:hover {
        color: white;
        background: ${props => props.theme.secondary_color_mid};
        border-color: transparent;
    }
`;

const openStyles = css`
    ${activeStyles}
`;

const StyledButton = styled.button`
    display: inline-block;
    padding: 1.5rem 2.5rem;
    
    cursor: pointer;
    transition: all .3s;
    text-decoration: none !important;
    
    outline: none !important;
    text-align: center;
    font-weight: 600;
    line-height: 2rem;
    
    color: white;
    border: .1rem solid ${props => props.theme.primary_color};
    background: ${props => props.theme.primary_color};
    
    &:hover {
        color: white;
        background: ${props => props.theme.primary_color_mid};
        border-color: ${props => props.theme.primary_color_mid};
    }
    
    &:disabled {
        pointer-events: none;
        opacity: .8;
    }
    
    ${props => props.open && openStyles}
    
    &[data-active] {
        ${activeStyles}
    }
`;
